import React from 'react';
import { ChevronLeft, ChevronRight, Star } from './icons';
import { formatDateKey, getFirstDayOfMonth } from '../utils/lunarUtils';

export default function CalendarGrid({
  t,
  currentDate,
  monthData,
  selectedDate,
  onSelectDate,
  favoriteSet,
  onPrevMonth,
  onNextMonth,
  onToday,
  getHolidayName,
  getLunarSpecialNote
}) {
  const firstDay = getFirstDayOfMonth(currentDate);
  const days = [];
  const todayKey = new Date().toDateString();

  for (let i = 0; i < firstDay; i++) {
    days.push(<div key={`empty-${i}`} className="empty-day"></div>);
  }

  monthData.days.forEach(({ date, lunar, holidays }) => {
    const isToday = todayKey === date.toDateString();
    const isSelected = selectedDate?.toDateString() === date.toDateString();
    const lunarNote = getLunarSpecialNote(lunar);
    const isFavorite = favoriteSet.has(formatDateKey(date));
    const hasHoliday = holidays.length > 0;
    const primaryHoliday = holidays[0];
    const extraHolidayCount = holidays.length > 1 ? holidays.length - 1 : 0;
    const dayOfWeek = date.getDay();
    const weekendClass = dayOfWeek === 6 ? 'saturday' : dayOfWeek === 0 ? 'sunday' : '';

    days.push(
      <button
        type="button"
        key={date.getDate()}
        onClick={() => onSelectDate(date)}
        className={[
          'day-cell',
          weekendClass,
          isSelected && 'selected',
          isToday && 'today',
          hasHoliday && 'holiday'
        ]
          .filter(Boolean)
          .join(' ')}
        aria-pressed={isSelected}
        aria-current={isToday ? 'date' : undefined}
      >
        <div className="day-number-row">
          <span>{date.getDate()}</span>
          {isFavorite && <Star size={14} className="day-favorite" aria-label={t.favorites} />}
        </div>
        <div className="day-lunar">
          {lunar.day}/{lunar.month}
        </div>
        {primaryHoliday && (
          <div className="day-holiday-label">
            {getHolidayName(primaryHoliday)}
            {extraHolidayCount > 0 && (
              <span className="day-holiday-count">{` +${extraHolidayCount}`}</span>
            )}
          </div>
        )}
        {lunarNote && (
          <div className="day-note-label">
            {lunarNote}
          </div>
        )}
      </button>
    );
  });

  return (
    <div className="card">
      <div className="month-nav">
        <button onClick={onPrevMonth} className="month-button" aria-label={t.prevMonthAria}>
          <ChevronLeft size={20} />
        </button>
        <h2 className="month-title">
          {t.monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
        </h2>
        <button onClick={onNextMonth} className="month-button" aria-label={t.nextMonthAria}>
          <ChevronRight size={20} />
        </button>
      </div>

      <div className="today-row">
        <button
          onClick={onToday}
          className="primary-button"
        >
          {t.today}
        </button>
      </div>

      <div className="day-names">
        {t.dayNames.map((day, index) => (
          <div
            key={day}
            className={[
              'day-name',
              index === 5 && 'day-name-saturday',
              index === 6 && 'day-name-sunday'
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {day}
          </div>
        ))}
      </div>

      <div className="calendar-grid">
        {days}
      </div>
    </div>
  );
}
